import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJAiVideoDubInput.module.less';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FJVideoInput from '../../../../common/components/FJVideoInput/FJVideoInput';
import { UPLOAD_FILE_TYPE_OF_VIDEO_DUB } from '../../../../redux/action/FJActionAiVideoDub';
import { CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS } from '../../../../config/dataConfig/FJGenerateData.js';
import classNames from 'classnames';

const FJAiVideoDubInput = ({
    showModal,
    onUploadVideo,
    videoInfo,
    onCrop,
    onDelete,
    isDraggingFile,
    setIsDraggingFile,
    disable,
    isUploadFileLoading,
    openMediaLibrary,
}) => {
    const currentLanguage = FJLocalStore.currentTag();

    const onClick = e => {
        e.stopPropagation();
        showModal();
    };

    const leftChild = useMemo(() => {
        const text = FJLocalStore._('upload-video-or-use');
        const parts = text.split(/<span>(.*?)<\/span>/);

        return (
            <div
                className={classNames(styles.left_child, {
                    [styles.disabled]: disable,
                })}
            >
                {parts.map((part, index) =>
                    index === 1 ? (
                        <div className={styles.ai_video} onClick={onClick} key={index}>
                            {part}
                        </div>
                    ) : (
                        part
                    ),
                )}
            </div>
        );
    }, [showModal, disable, currentLanguage]);

    return (
        <div className={styles.input_container}>
            <FJVideoInput
                uploadVideoInfo={videoInfo}
                // leftChild={leftChild}
                style={{ height: 80 }}
                isShowCrop={true}
                uploadText={leftChild}
                onCrop={onCrop}
                uploadVideo={onUploadVideo}
                acceptFile={UPLOAD_FILE_TYPE_OF_VIDEO_DUB.join(',') + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS}
                onDelete={onDelete}
                isDraggingFile={isDraggingFile}
                setIsDraggingFile={setIsDraggingFile}
                disable={disable}
                isLoading={isUploadFileLoading}
                openMediaLibrary={openMediaLibrary}
            />
        </div>
    );
};

FJAiVideoDubInput.propTypes = {
    showModal: PropTypes.func.isRequired,
    onUploadVideo: PropTypes.func.isRequired,
    videoInfo: PropTypes.object.isRequired,
    onCrop: PropTypes.func,
    onDelete: PropTypes.func,
    isDraggingFile: PropTypes.bool.isRequired,
    setIsDraggingFile: PropTypes.func.isRequired,
    disable: PropTypes.bool,
    isUploadFileLoading: PropTypes.bool.isRequired,
    openMediaLibrary: PropTypes.func,
};

export default FJAiVideoDubInput;
